export default "__VITE_ASSET__BZi3XooG__"